//things that make the interface cool
import * as $ from 'jquery';
import * as Cookies from 'js-cookie';
import 'bootstrap'
import 'select2'
import 'selectize'
import 'jquery-validation'
import sortable from "html5sortable/dist/html5sortable.cjs";

export default (function () {
    sortable('.sortable', {
        acceptFrom: '.sortable',
        // items: '.crm-card',
        placeholderClass: 'bg-light border-dashed p-5 mb-2',
        itemSerializer: (serializedItem, sortableContainer) => {
            return {
                id: serializedItem.node.dataset.id,
                position: serializedItem.index + 1,
            }
        },
        containerSerializer: (serializedContainer) => {
            return {
                status: serializedContainer.node.dataset.status
            }
        }
    });

    sortable('.sortable').forEach((item, index) => item.addEventListener('sortupdate', function (e) {
            window.livewire.emit("updateColumn", {
                'item': e.detail.item.dataset.id,
                'originStatus': e.detail.origin.container.dataset.status,
                'destinationStatus': e.detail.destination.container.dataset.status,
                'orderData': sortable('.sortable', 'serialize')[index]
            });
        })
    )

    $.validator.addMethod('nofreeemail', function (value) {
        return /^([\w-.]+@(?!gmail\.com)(?!yahoo\.com)(?!hotmail\.com)([\w-]+.)+[\w-]{2,4})?$/.test(value);
    }, 'Please use your work email');

    $(".has-validation form").validate({
        rules: {
            email: {
                required: true,
                minlength: 2,
                nofreeemail: true
            },
        }
    });

    $('.line-placeholder').each(function () {
        let width = $(this).data('width');
        $(this).delay(100).css('width', width);
    })

    $('.set-cookie-button').on('click', function (e) {
        e.preventDefault();
        var cookie = $(this).data('cookie');
        var value = $(this).data('value');
        var hide = $(this).data('hide');
        if (hide) {
            $(hide).fadeOut();
        }
        Cookies.set(cookie, value);
    })

    /*

    Chatbot

    */
    $('a.open-chatbot').on('click', function (e) {
        e.preventDefault();
        if (Intercom) {
            Intercom('show');
        }
        ;
    })

    /*

     On Radio Button Div Toggle

     */
    $('input.radio-toggle-option[type=radio]').change(function () {
        $('.radio-tabs .radio-tab, .tab-to-hide').hide();
        $('.should-be-required').attr({'disabled': true, 'required': false});
        var show = $(this).data('show');
        var tabToShow = $("." + show);
        tabToShow.show();
        tabToShow.find('.should-be-required').attr({'disabled': false, 'required': true});

    }).trigger('change');
    $('input.radio-toggle-option[type=radio]:checked').trigger('change');

    /*

     On Checkbox Check Div Toggle

     */
    $('input.check-toggle-option[type=checkbox]').change(function () {
        var show = $(this).data('show');
        var tabToShow = $("." + show);
        if ($(this).is(':checked')) {
            tabToShow.show();
        } else {
            tabToShow.hide();
        }
    }).trigger('change');

    /*

    Toggle & Disappear

    */
    $('.toggle-and-disappear').on('click', function (e) {
        e.preventDefault();
        var togglingDiv = $(this).data('toggle');
        $(this).hide();
        $('#' + togglingDiv).fadeIn();
    })

    /*

     Checkbox Bool Values

     */

    $('input[type="checkbox"].checkbox-bool-value').change(function () {
        this.value = (Number(this.checked));
    });

    $('[data-toggle="tooltip"]').tooltip()
    $('[rel="tooltip"]').tooltip({trigger: "hover"});

    $('.toggle-show-link').on('click', function (e) {
        e.preventDefault();
        var showDiv = $(this).data('show');
        var hideDiv = $(this).data('hide');
        $('.' + showDiv).fadeIn();
        $('.' + hideDiv).hide();
    })

    $('#app').on('change', '.investor-select-checkbox', function () {
        var investorIds = $.map($('.investor-select-checkbox:checked'), function (n, i) {
            return n.value;
        });
        if (investorIds.length) {
            $('.bulk-select-display').show().find('.number-selected').text(investorIds.length);
            $('.no-bulk-selections').hide();
        } else {
            $('.no-bulk-selections').show();
            $('.bulk-select-display').hide();
        }
        $('.multiple-action-toolbar a.ajax-add-to-list, .multiple-action-toolbar a.ajax-set-status').attr('data-model', investorIds.join(',')).attr('data-investor', investorIds.join(','))
    });

    $('.select-all-investors').on('click', function (e) {
        e.preventDefault();
        $('.investor-select-checkbox').prop('checked', 'checked').trigger('change');
    })

    $('.deselect-all-investors').on('click', function (e) {
        e.preventDefault();
        $('.investor-select-checkbox:checked').prop('checked', false).trigger('change');
    })

    /*

    Dropdown madness

    */
    $('#app').on('click', '.dropdown-menu a.dropdown-toggle', function (e) {
        if (!$(this).next().hasClass('show')) {
            console.log('top thing')
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            console.log(' bottom thing')
            $('.dropdown-submenu .show').removeClass("show");
        });

        return false;
    });

    $('#app').on('click', '.dropdown', function () {
        this.closable = false;
    });
    $('#app').on('shown.bs.dropdown', '.dropdown', function () {
        this.closable = false;
    });
    $('#app').on('hide.bs.dropdown', '.dropdown', function () {
        return this.closable;
    });

    $('body').on('click', function (e) {
        if (!$('.dropdown').is(e.target)
            && $('.dropdown').has(e.target).length === 0
            && $('.open').has(e.target).length === 0
        ) {
            $('.dropdown-menu').removeClass("show");
        }
    });

    $('#app').on('click', '.dropdown-menu.close-on-click a', function () {
        console.log('thing');
        $(this).closest('.dropdown-menu').removeClass("show");
    })

    /*

    SELECT2 and its better friends

    */

    $('.selectize').selectize({
        plugins: ["remove_button"]
    });

    //used everywhere except CRM
    $('.js-example-basic-multiple').selectize({
        plugins: ["remove_button"]
    });

    //only used on CRM
    $('.js-custom-select').select2({
        "minimumResultsForSearch": "Infinity",
        "dropdownAutoWidth": true,
        "width": "auto"
    });

    $('.livewire-select2').on('select2:select', function (e) {
        Livewire.emit('updateType', e.target.value)
    });

    $('#filterForm').removeClass('d-none');

    // this is the id of the form
    $('#app').on('submit', "#ajax-note-form", function (e) {

        e.preventDefault(); // avoid to execute the actual submit of the form.

        var form = $(this);
        var url = form.attr('action');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function (data) {
                //yay
                form.html('');
                form.next('.note-success').show();
            }
        });

    });

    $('#app').on('submit', ".ajax-intro-form", function (e) {

        e.preventDefault(); // avoid to execute the actual submit of the form.

        var form = $(this);
        var url = form.attr('action');
        var investor_id = form.find('input.item-id-input').first().val();

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function (data) {
                //yay
                form.html('');
                form.next('.note-success').show();
                $('.request-intro-button[data-investor-id=' + investor_id + ']').html(' <i class="far fa-check-circle"></i> Intro Requested!').prop('disabled', true);
            }
        });

    });


    /*

    AJAX Add to List

    */

    $('#app').on('click', '.ajax-add-to-list', function (e) {
        e.preventDefault();

        var parent = $(this).closest('.dropdown').find('.add-to-list-parent');

        startButtonLoading(parent);

        var investor = $(this).data('investor');
        var list = $(this).data('list');
        var link = $(this).data('link');

        $.ajax({
            type: "GET",
            url: $(this).attr('href'),
            data: {investor_ids: investor},
            headers: {
                'X-CSRF-Token': '{{ csrf_token() }}',
            },
            success: function (data) {
                stopButtonLoading(parent);
                parent.html('&nbsp; <i class="fas fa-check"></i> ');
                window.setTimeout(function () {
                    parent.html('Add to Contact List');
                }, 3000);

            },
            error: function (data) {
                //straight from the route messaging
                alert(`There was an error: ${data.responseJSON.message}`);
            }
        });
    })

    /*

    AJAX Set Status

    */

    $('#app').on('click', '.ajax-set-status', function (e) {
        e.preventDefault();
        var el = $(this);
        var parent = $(this).closest('.dropdown').find('.set-status-parent');

        startButtonLoading(parent);

        var investor = $(this).data('model');
        var investor_id = $(this).data('model-id');
        var status_id = $(this).data('status-id');
        var status_name = $(this).text();
        var link = $(this).data('link');
        var type = $(this).data('type');

        $.ajax({
            type: "GET",
            url: $(this).attr('href') + '?status_id=' + status_id + '&status_name=' + status_name + '&type=' + type + '&investor_ids=' + investor,
            headers: {
                'X-CSRF-Token': '{{ csrf_token() }}',
            },
            success: function (data) {
                stopButtonLoading(parent);
                parent.text('Status: ' + status_name)
                $(`tr[data-investor-id="${investor_id}"]`).find('.badge').text(status_name);

                if (investor) {
                    var investors = investor.toString().split(',');
                    investors.forEach(function (element, index) {
                        $(`tr[data-investor-id="${element}"]`).find('.badge').text(status_name);
                    });
                }


            },
            error: function (data) {
                //straight from the route messaging
                alert(`There was an error: ${data.responseJSON.message}`);
            }
        });
    })


    $('#generateList').on('click', function (e) {
        e.preventDefault();
        var el = $(this);
        var company = el.data('company');
        el.html(`Indexing ${company} data`);
        startButtonLoading(el);
        $('#showInvestorList').show();
        $.ajax({
            type: "GET",
            url: $(this).attr('href'),
            headers: {
                'X-CSRF-Token': '{{ csrf_token() }}',
            },
            success: function (data) {
                $('#listWrapper').html(data);
                el.delay(2000).show(1, function () {
                    el.html(`Searching for investors`)
                    startButtonLoading(el);
                }).delay(4000).show(1, function () {
                    showResults();


                });
                // stopButtonLoading(el);
                // el.closest('#generateInvestorList').hide();
            },
            error: function (data) {
                //straight from the route messaging
                alert(`There was an error: ${data.responseJSON.message}`);
            }
        });
    });

    $(document).on('click', '#generateMoreMatches', function (e) {
        e.preventDefault();
        var el = $(this);
        var company = el.data('company');
        el.html(`Searching for additional ${company} matches...`);
        startButtonLoading(el);
        // $('#showInvestorList').show();
        $.ajax({
            type: "GET",
            url: $(this).attr('href'),
            headers: {
                'X-CSRF-Token': '{{ csrf_token() }}',
            },
            success: function (data) {
                console.log(data);
                $('#listWrapper').append(data);
                el.delay(2000).show(1, function () {
                    el.html(`Searching for investors`)
                    startButtonLoading(el);
                }).delay(4000).show(1, function () {
                    console.log('show results?');
                    showMoreResults();


                });
                // stopButtonLoading(el);
                // el.closest('#generateInvestorList').hide();
            },
            error: function (data) {
                //straight from the route messaging
                alert(`There was an error: ${data.responseJSON.message}`);
            }
        });
    });

    $.fn.select2ToTree = function (options) {
        var opts = $.extend({}, options);

        if (opts.treeData) {
            buildSelect(opts.treeData, this);
        }

        opts._templateResult = opts.templateResult;
        opts.templateResult = function (data, container) {
            var label = data.text;
            if (typeof opts._templateResult === "function") {
                label = opts._templateResult(data, container);
            }
            var $iteme = $("<span class='item-label'></span>").append(label);
            if (data.element) {
                var ele = data.element;
                container.setAttribute("data-val", ele.value);
                if (ele.className) container.className += " " + ele.className;
                if (ele.getAttribute("data-pup")) {
                    container.setAttribute("data-pup", ele.getAttribute("data-pup"));
                }
                if ($(container).hasClass("non-leaf")) {
                    return $.merge($('<span class="expand-collapse" onmouseup="expColMouseupHandler(event);"></span>'), $iteme);
                }
            }
            return $iteme;
        };

        window.expColMouseupHandler = function (evt) {
            toggleSubOptions(evt.target || evt.srcElement);
            /* prevent Select2 from doing "select2:selecting","select2:unselecting","select2:closing" */
            evt.stopPropagation ? evt.stopPropagation() : evt.cancelBubble = true;
            evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
        }

        var s2inst = this.select2(opts);

        s2inst.on("select2:open", function (evt) {
            var s2data = s2inst.data("select2");
            s2data.$dropdown.addClass("s2-to-tree");
            s2data.$dropdown.removeClass("searching-result");
            var $allsch = s2data.$dropdown.find(".select2-search__field").add(s2data.$container.find(".select2-search__field"));
            $allsch.off("input", inputHandler);
            $allsch.on("input", inputHandler);
        });

        /* Show search result options even if they are collapsed */
        function inputHandler(evt) {
            var s2data = s2inst.data("select2");
            if ($(this).val().trim().length > 0) {
                s2data.$dropdown.addClass("searching-result");
            } else {
                s2data.$dropdown.removeClass("searching-result");
            }
        }

        return s2inst;
    };

    /* Build the Select Option elements */
    function buildSelect(treeData, $el) {

        /* Support the object path (eg: `item.label`) for 'valFld' & 'labelFld' */
        function readPath(object, path) {
            var currentPosition = object;
            for (var j = 0; j < path.length; j++) {
                var currentPath = path[j];
                if (currentPosition[currentPath]) {
                    currentPosition = currentPosition[currentPath];
                    continue;
                }
                return 'MISSING';
            }
            return currentPosition;
        }

        function buildOptions(dataArr, curLevel, pup) {
            var labelPath;
            if (treeData.labelFld && treeData.labelFld.split('.').length > 1) {
                labelPath = treeData.labelFld.split('.');
            }
            var idPath;
            if (treeData.valFld && treeData.valFld.split('.').length > 1) {
                idPath = treeData.valFld.split('.');
            }

            for (var i = 0; i < dataArr.length; i++) {
                var data = dataArr[i] || {};
                var $opt = $("<option></option>");
                if (labelPath) {
                    $opt.text(readPath(data, labelPath));
                } else {
                    $opt.text(data[treeData.labelFld || "text"]);
                }
                if (idPath) {
                    $opt.val(readPath(data, idPath));
                } else {
                    $opt.val(data[treeData.valFld || "id"]);
                }
                if (data[treeData.selFld || "selected"] && String(data[treeData.selFld || "selected"]) === "true") {
                    $opt.prop("selected", data[treeData.selFld || "selected"]);
                }
                if ($opt.val() === "") {
                    $opt.prop("disabled", true);
                    $opt.val(getUniqueValue());
                }
                $opt.addClass("l" + curLevel);
                if (pup) $opt.attr("data-pup", pup);
                $el.append($opt);
                var inc = data[treeData.incFld || "inc"];
                if (inc && inc.length > 0) {
                    $opt.addClass("non-leaf");
                    buildOptions(inc, curLevel + 1, $opt.val());
                }
            } // end 'for'
        } // end 'buildOptions'

        buildOptions(treeData.dataArr, 1, "");
        if (treeData.dftVal) $el.val(treeData.dftVal);
    }

    var uniqueIdx = 1;

    function getUniqueValue() {
        return "autoUniqueVal_" + uniqueIdx++;
    }

    function toggleSubOptions(target) {
        $(target.parentNode).toggleClass("opened");
        showHideSub(target.parentNode);
    }

    function showHideSub(ele) {
        var curEle = ele;
        var $options = $(ele).parent(".select2-results__options");
        var shouldShow = true;
        do {
            var pup = ($(curEle).attr("data-pup") || "").replace(/'/g, "\\'");
            curEle = null;
            if (pup) {
                var pupEle = $options.find(".select2-results__option[data-val='" + pup + "']");
                if (pupEle.length > 0) {
                    if (!pupEle.eq(0).hasClass("opened")) { // hide current node if any parent node is collapsed
                        $(ele).removeClass("showme");
                        shouldShow = false;
                        break;
                    }
                    curEle = pupEle[0];
                }
            }
        } while (curEle);
        if (shouldShow) $(ele).addClass("showme");

        var val = ($(ele).attr("data-val") || "").replace(/'/g, "\\'");
        $options.find(".select2-results__option[data-pup='" + val + "']").each(function () {
            showHideSub(this);
        });
    }

    $(".select-tree").select2ToTree({closeOnSelect: false});
    //this is stupid but it freaks if there's more than one on the page
    $(".select-tree-additional").select2ToTree();


    function showResults() {
        var firstResult = $('#listWrapper tr').first();
        var total = firstResult.data('total');
        var highestConfidence = firstResult.data('confidence');
        $('#investorCount').html(total);
        showTr($('#listWrapper tr').first());
        if (highestConfidence < 3) {
            $('#low-confidence-alert').fadeIn();
        }
        $('#generateList').fadeOut();
    }

    function showMoreResults() {
        // var total = $('#listWrapper tr').first().data('total');
        // $('#investorCount').html(total);
        $('.generate-more-results-wrapper').first().remove();
        showTr($('#listWrapper tr:hidden').first());
    }

    function showTr(el) {

        el.delay(randomIntFromInterval(100, 1000)).fadeIn(function () {

            if (el.next('tr').length) {
                showTr(el.next('tr'));
            } else {
                console.log('all done');
                var total = $('#investorCount').html();
                $('.investor-total-count').html(`${total} Investors Found`);
                // $('#generateMoreMatches').html(`${total} Investors Found`)
            }
        });

    }

    /*

    Link confirm prompt buttons

    */
    $('#app').on('click', '.link-confirm', function (e) {
        return confirm($(this).data('confirm'));
    })

    /*

    Filter Sorting

    */
    var countries = [];
    var countriesInput = $('input[name="countries"]');

    var markets = [];
    var marketsInput = $('input[name="markets"]');

    var sectors = [];
    var sectorsInput = $('input[name="sectors"]');

    var stages = [];
    var stagesInput = $('input[name="stages"]');

    var types = [];
    var typesInput = $('input[name="firm_types"]');

    $('.js-example-basic-multiple, .clone-to-input').on('change', function (e) {
        var arr = $(this).data('input');
        var val = $(this).val();
        eval(arr).length = 0;
        eval(arr).push(val);
        $("input[name=" + arr + "]").val(eval(arr).join());
    })

    $('#filterSubmit').on('click', function (e) {
        e.preventDefault();
        $('.clear-on-submit').prop('disabled', true);
        $('#filterForm').submit();
    })

    function randomIntFromInterval(min, max) { // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    function startButtonLoading(el) {
        el.disabled = true;
        el.append('<span class="spinner-border mx-2 spinner-border-sm" role="status" aria-hidden="true"></span>');
    }

    function stopButtonLoading(el) {
        el.disabled = false;
        el.find('.spinner-border').remove();
    }

}());
